var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("Header", { attrs: { placeholder: _vm.appPlaceholder } }),
      _c(
        "div",
        { staticClass: "div-center", style: _vm.appContainerStyle },
        [_c("KeepAlive", [_c("RouterView")], 1)],
        1
      ),
      _c("Footer"),
      _c("Register", { ref: "registerRef" }),
      _c("BackToTop", { attrs: { visible: _vm.appTopVisible } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }